import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * Cache em nível de módulo — persiste durante toda a sessão do app,
 * evitando múltiplas chamadas ao servidor enquanto o usuário navega.
 * Zerado automaticamente quando o módulo é descarregado (logout/reload).
 */
let _userCache = null;

/**
 * Hook que retorna o usuário autenticado atual.
 *
 * Uso:
 *   const currentUser = useCurrentUser();
 *   currentUser?.perfil   // 'admin_geral' | 'admin' | 'financeiro' | ...
 *   currentUser?.nome     // 'João Silva'
 *   currentUser?.id       // 42
 *
 * Retorna `null` enquanto a requisição estiver pendente.
 */
export function useCurrentUser() {
  const [user, setUser] = useState(_userCache);

  useEffect(() => {
    // Já está em cache — não faz nova chamada
    if (_userCache) return;

    let cancelled = false;

    api.get('/api/auth/me')
      .then(({ data }) => {
        if (cancelled) return;
        _userCache = data;
        setUser(data);
      })
      .catch(() => {
        // Silencia: se falhar, user permanece null e canCreateCat = false
      });

    return () => { cancelled = true; };
  }, []);

  return user;
}

/**
 * Limpa o cache do usuário.
 * Chame no logout para garantir que o próximo usuário
 * não herde os dados do anterior.
 *
 * Exemplo no handler de logout:
 *   import { clearCurrentUserCache } from '../hooks/useCurrentUser';
 *   clearCurrentUserCache();
 */
export function clearCurrentUserCache() {
  _userCache = null;
}